import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    downloadUrl: String
  }

  download() {
    window.location.href = this.downloadUrlValue
  }
} 